import { NATIONAL_CURRENCY } from '../constants';
var isInternationalPrice = function isInternationalPrice(product) {
  var _ref = (product == null ? void 0 : product.price) || {},
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? NATIONAL_CURRENCY : _ref$currency;
  return currency !== NATIONAL_CURRENCY;
};
export default isInternationalPrice;